/* eslint-disable @next/next/no-img-element */
import { useState, useEffect } from "react";
import { FaCheck, FaRegSquare } from "react-icons/fa6";
import Slider from "react-slider";
import { useRouter } from "next/router";
import PropTypes from "prop-types";
import { filterImageFormatter, toSolrRange } from "./helper";

const FilterItems = ({
  filterOption,
  filterType = "list",
  filterName = "",
  minRange = 0,
  maxRange = 0,
  filterField = "",
  filterSelect = () => {},
  selectedFilter = {},
  selectedFilterCount = {},
  totalProductCount = 0,
}) => {
  const onClickHandler = (field = "", name = "", value = "", count = 0) => {
    let modifiedValue = name === "Price Range" ? toSolrRange(value) : value;
    filterSelect({ [field]: modifiedValue }, { [name]: count });
  };

  const [values, setValues] = useState([minRange, maxRange]);
  const handleChange = (newValues, additionalValue) => {
    setValues(newValues);
  };
  const handleMouseUp = (newValues, additionalValue) => {
    // Perform actions after mouse is released
    let maxName = `${additionalValue}Max`;
    let minName = `${additionalValue}Min`;
    filterSelect({ [minName]: newValues[0], [maxName]: newValues[1] });
    setIsRange(true);
  };

  const isFilterActive = !!selectedFilter?.[filterName];

  return (
    <div className="flow-root pb-[20px]">
      {isFilterActive ? (
        <ul
          key={`active-${filterName}-${selectedFilter?.[filterName]}`}
          className={`m-0 mb-[10px]  outline-none ${
            filterType === "checkbox" ? "bg-white" : "bg-[#e5e5e5]"
          } text-gray-800 inline-block border-0 rounded-md relative text-left w-full`}
        >
          <li
            className=""
            onClick={() => {
              onClickHandler(filterField, filterName);
            }}
          >
            <button
              className={`m-0 outline-none ${
                filterType === "checkbox" ? "bg-white" : "bg-[#e5e5e5]"
              } text-gray-800 inline-block border-0 rounded-md relative text-left w-full pt-[11.5px] pb-[11.5px] pr-[30px] pl-[10px]`}
            >
              {filterType === "checkbox" && (
                <div className="float-left mr-[10px] mt-[10px] text-base leading-normal font-normal shadow-none font-helvaticaFont">
                  <span className="inline float-left pt-1 mr-3 h-[29px] w-[29px] rounded-sm bg-[#f0f0f0] ">
                    <FaCheck size={20} className="m-auto" />
                  </span>
                  <span className="inline float-left">
                    {selectedFilter?.[filterName]}
                  </span>
                </div>
              )}
              {filterType === "image" && (
                <>
                  <span>
                    <img
                      className="inline-block h-[13px] w-[13px] mr-[10px]"
                      src={filterImageFormatter(
                        "",
                        selectedFilter?.[filterName],
                        filterOption
                      )}
                      alt=""
                      title={selectedFilter?.[filterName]}
                    />
                  </span>
                  <span className="text-[12px] font-semibold">
                    {selectedFilter?.[filterName]}
                  </span>
                </>
              )}
              {filterType === "list" && (
                <span className="leading-normal shadow-none leading-[13px] font-[400] font-[helveticaBold,_Helvetica,_sans-serif] text-[13px]">
                  {selectedFilter?.[filterName]}
                </span>
              )}
              <span className="text-[13px] font-semibold text-[#999]">
                {` (${totalProductCount})`}
              </span>
              <span className="absolute right-[15px] top-[11px] text-gray-400 font-normal text-base">
                x
              </span>
            </button>
          </li>
        </ul>
      ) : (
        <>
          {filterType === "checkbox" &&
            filterOption.map((data, index) => {
              return (
                <ul key={data.value || index} style={{ listStyle: "none" }}>
                  <li className="cursor-pointer">
                    <div
                      onClick={() =>
                        onClickHandler(
                          filterField,
                          filterName,
                          data.value,
                          data.count
                        )
                      }
                      className="flex"
                    >
                      <span className="flex">
                        <FaRegSquare size={23} />
                      </span>
                      <span className="flex pl-3">{data.value}</span>
                      <span className="flex ml-[5px]">({data.count})</span>
                    </div>
                  </li>
                </ul>
              );
            })}
          {filterType === "image" && !isFilterActive && filterOption.length && (
            <ul className="">
              {filterOption.map((data, index) => {
                return (
                  <li
                    key={data.name || data.value}
                    className="block float-left mt-[10px] mb-[5px] m-[1px] mr-[7px]"
                  >
                    <button
                      type="button"
                      className="cursor-pointer p-0 border-0 bg-transparent hover:outline-3 hover:outline-[#666] hover:outline-solid hover:-outline-offset-3 hover:[box-shadow:inset_0_0_0_2px_#666]"
                      title={`${data.value}(${data.count})`}
                      onClick={() => {
                        onClickHandler(
                          filterField,
                          filterName,
                          data.value,
                          data.count
                        );
                      }}
                    >
                      <img
                        alt={`${data.value}(${data.count})`}
                        src={filterImageFormatter(data.name)}
                        style={{ pointerEvents: "none" }}
                      />
                    </button>
                  </li>
                );
              })}
            </ul>
          )}
          {filterType === "list" &&
            filterOption.map((data, index) => {
              return (
                <ul key={index}>
                  <li
                    className="cursor-pointer"
                    onClick={() => {
                      onClickHandler(
                        filterField,
                        filterName,
                        data.value,
                        data.count
                      );
                    }}
                  >
                    <span className="inline-block pt-[10px] pb-[10px]">
                      {data.value}
                    </span>
                    <span className="text-[#999] text-base ml-[5px]">
                      ({data.count})
                    </span>
                  </li>
                </ul>
              );
            })}
          {filterType === "range" && (
            <div>
              {isRange && (
                <ul className="m-0 mb-[10px] outline-none bg-gray-300 text-gray-800 inline-block border-0 rounded-md relative text-left w-full">
                  <li
                    className=""
                    onClick={() => {
                      onClickHandler(filterField, "");
                    }}
                  >
                    <button className="m-0 mb-[10px] outline-none bg-gray-300 text-gray-800 inline-block border-0 rounded-md relative text-left w-full">
                      {" "}
                      <span className="block float-left max-w-[13px] h-13 mr-[10px] mt-[10px] ml-[10px] ">
                        {values[0]}
                      </span>
                      <span className="float-left  mr-[10px] mt-[10px] ml-[15px] text-base leading-normal font-normal text-gray-600">
                        -
                      </span>
                      <span className="float-left  mr-[10px] mt-[10px]  text-base leading-normal font-normal text-gray-600">
                        {values[1]}
                      </span>
                      <span className="absolute mt-[10px] right-4 text-gray-400 font-normal text-base">
                        x
                      </span>
                    </button>
                  </li>
                </ul>
              )}
              <div
                className="font-bold text-base leading-normal font-helvaticaFont"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <div>
                  <span
                    onChange={e =>
                      handleChange([
                        +e.target.value,
                        selectedFilter?.[`${filterName}Max`]
                          ? selectedFilter?.[`${filterName}Max`]
                          : values[1],
                      ])
                    }
                  >
                    {selectedFilter?.[`${filterName}Min`]
                      ? selectedFilter?.[`${filterName}Min`]
                      : values[0]}
                    {"mm"}
                  </span>
                </div>
                <div>
                  <span
                    onChange={e =>
                      handleChange([
                        selectedFilter?.[`${filterName}Min`]
                          ? selectedFilter?.[`${filterName}Min`]
                          : values[0],
                        +e.target.value,
                      ])
                    }
                  >
                    {selectedFilter?.[`${filterName}Max`]
                      ? selectedFilter?.[`${filterName}Max`]
                      : values[1]}
                    {"mm"}
                  </span>
                </div>
              </div>
              <Slider
                value={
                  selectedFilter?.[`${filterName}Min`]
                    ? [
                        selectedFilter?.[`${filterName}Min`],
                        selectedFilter?.[`${filterName}Max`],
                      ]
                    : values
                }
                onChange={newValues => handleChange(newValues, filterName)}
                onAfterChange={newValues =>
                  handleMouseUp(newValues, filterName)
                }
                min={minRange}
                max={maxRange}
                renderThumb={props => (
                  <div className="custom-thumb" {...props}>
                    <div className="custom-thumb-before"></div>
                    <div className="custom-thumb-after"></div>
                  </div>
                )}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};

FilterItems.propTypes = {
  filterOption: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      name: PropTypes.string,
      count: PropTypes.number,
    })
  ).isRequired,
  filterType: PropTypes.oneOf(["checkbox", "image", "list", "range"])
    .isRequired,
  filterName: PropTypes.string.isRequired,
  minRange: PropTypes.number,
  maxRange: PropTypes.number,
  filterSelect: PropTypes.func.isRequired,
  selectedFilter: PropTypes.object.isRequired,
  selectedFilterCount: PropTypes.object.isRequired,
};

export default FilterItems;
